

document.addEventListener("DOMContentLoaded", function () {
  HelpCenter.init({
    toggler: "help-center-toggler",
    container: "help-center",
  });
});
